import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { url: String, sizeParam: String }

    change(event) {
        const bulkElement = this.element.closest('[data-controller~="bulk"]')
        this.application.getControllerForElementAndIdentifier(bulkElement || this.element, "bulk")?.resetSelection()
        const url = new URL(this.urlValue, window.location.origin)
        url.searchParams.set(this.sizeParamValue, event.target.value)
        const frame = this.element.closest("turbo-frame")
        Turbo.visit(url.toString(), frame ? { frame: frame.id } : {})
    }
}
